<template>
  	<b-container fluid>
		<page-title><h2><router-link :to="{ name: 'AgreementList' }" class="nav-link">Umowy</router-link>/<span v-if="item && !loading">{{ item.customerData.name }}/{{ item['fullNumber'] }}</span></h2>
			<div v-if="item && !loading" class="page-title__buttons">
				<router-link :to="{name: 'AgreementUpdate', params: { id: item['id'] }}" title="Edytuj" class="btn btn-default"><span>Edytuj</span><svg-icon name="edit"/></router-link>
				<a v-if="item.invoice == null" href="#" @click.prevent="deleteItem" title="usuń" class="btn btn-primary"><span>Usuń</span><svg-icon name="minus"/></a>
			</div>
		</page-title>

		<div class="col page-element">
			<div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>
			<div v-if="deleteError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>Nie udało się usunąć umoawy. Aby usunięcie umowy było możliwe umowa nie może zawierać faktur\Potrąceń\Zaliczek\Zwrotów ani faktury wystawionej do tej umowy</div>
			<alert-loading v-if="loading"></alert-loading>

			<div v-if="item && !loading" class="row">
				<div class="col-md-6">
					<table class="table table-data">
						<tbody>
							<tr>
								<td>Numer</td>
								<td>{{ item['fullNumber'] }}</td>
							</tr>
							<tr>
								<td>Data zawarcia</td>
								<td>{{ item['date'] | date }}</td>
							</tr>
							<tr>
								<td>Status</td>
								<td><span class="element_status" :class="item.status">{{ item['status'] | translate }}</span></td>
							</tr>
							<tr v-if="item.leftToPaid > 0">
								<td>Suma faktur niezapłaconych</td>
								<td>{{ item.leftToPaid }}</td>
							</tr>
							<tr v-if="item.paidOn">
								<td>Data spłaty</td>
								<td>{{ item.paidOn | date }} </td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="col-md-6">
					<table class="table table-data">
						<tbody>
							<tr>
								<td>Waluta</td>
								<td>{{ item.currency.name }}</td>
							</tr>
							<tr>
								<td>Prowizja</td>
								<td>{{ item['commission'] | percentage}}</td>
							</tr>
							<tr>
								<td>Klient</td>
								<td><router-link v-if="item" :to="{name: 'CustomerShow', params: { id: item['customer']}}">{{ item.customerData.name }}</router-link></td>
							</tr>
							<tr v-if="item.invoice">
								<td>Faktura</td>
								<td><router-link v-if="item" :to="{name: 'InvoiceShow', params: { id: item.invoice.id}}">{{ item.invoice.fullNumber }}</router-link></td>

							</tr>
							<tr v-if="item.comments">
								<td>Uwagi</td>
								<td>{{ item['comments'] }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<div v-if="item && !loading" class="col page-element">
			<page-title><h3>Lista faktur</h3></page-title>
			<invoice-list :id="item['id']"></invoice-list>
		</div>
	</b-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import invoiceList from './invoiceList.vue'

  export default {
    components:{
      "invoice-list": invoiceList
	},
    computed: mapGetters({
      deleteError: 'agreement/del/error',
      deleted: 'agreement/del/deleted',
      error: 'agreement/show/error',
      loading: 'agreement/show/loading',
      item: 'agreement/show/item',
    }),
    methods: {
      deleteItem (item) {
        if (window.confirm('Czy na pewno chce usunąć tą umowę?'))
          this.$store.dispatch('agreement/del/delete', this.item);
      }
    },
    created () {
      this.$store.dispatch('agreement/show/retrieve', this.$route.params.id);
    },
    beforeDestroy() {
      this.$store.dispatch('agreement/show/reset');
      this.$store.dispatch('agreement/del/reset');
    },
    watch: {
      deleted: function (deleted) {
        if (deleted) {
          this.$router.push({ name: 'AgreementList' });
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// Show.vue?64f3e857